import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import isFunction from 'lodash-es/isFunction';
import { SidenavItem } from 'src/app/models/menu-item';
import { SidenavCategory } from "src/app/models/SidenavCategory";
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'app-sidenav-item',
    templateUrl: './sidenav-item.component.html',
    styleUrls: ['./sidenav-item.component.scss'],
    animations: [
        trigger('dropdownOpen', [
            state('false', style({
                height: 0
            })),
            state('true', style({
                height: '*'
            })),
            transition('false <=> true', animate('300ms cubic-bezier(.35, 0, .25, 1)'))
        ])
    ],
    standalone: false
})
export class SidenavItemComponent implements OnInit {

  @Input('item') item: SidenavCategory | SidenavItem | undefined;
  @Input('level') level: number = 0;

  isCollapsed$ = this.sidenavService.collapsed$;
  dropdownOpen$: Observable<boolean>;

  constructor(private readonly sidenavService: SidenavService, private readonly router: Router) {
    this.dropdownOpen$ = this.sidenavService.currentlyOpen$.pipe(
      map((currentlyOpen: any) => (this.item instanceof SidenavCategory) && this.item?.items && this.item?.items.length > 0 && currentlyOpen.indexOf(this.item) > -1)
    ) ;
  }

  get levelClass() {
    return `level-${this.level}`;
  }

  ngOnInit() {
    if (this.item && this.item instanceof SidenavCategory){
      if (this.item.items && this.item.items.length > 0) {
        const auxItem = this.item;
        for (let auxitem of this.item.items){
          if (auxitem.itemRouteOrFunction == this.router.url) {
            this.sidenavService.toggleItemOpen(auxItem);
            break;
          }
        }

      }
    }

  }

  isFunction(routeOrFunction: string[] | Function) {
    return isFunction(routeOrFunction);
  }

  handleClick() {
    if (this.item && this.item instanceof SidenavCategory){
      if (this.item.items && this.item.items.length > 0) {
        this.sidenavService.toggleItemOpen(this.item);
      } else if (typeof this.item.categoryRouteOrFunction === 'string' || this.item.categoryRouteOrFunction instanceof String) {
        this.router.navigate([this.item.categoryRouteOrFunction]);
      } else if (typeof this.item.categoryRouteOrFunction === 'function' || this.item.categoryRouteOrFunction instanceof Function) {
        this.item.categoryRouteOrFunction();
      } else {
        throw Error('Could not determine what to do, Sidenav-Item has no routeOrFunction set AND does not contain any subItems');
      }
    } else if (this.item && this.item instanceof SidenavItem){
      if (typeof this.item.itemRouteOrFunction === 'string' || this.item.itemRouteOrFunction instanceof String) {
        this.router.navigate([this.item.itemRouteOrFunction]);
      } else if (typeof this.item.itemRouteOrFunction === 'function' || this.item.itemRouteOrFunction instanceof Function) {
        this.item.itemRouteOrFunction();
      } else {
        throw Error('Could not determine what to do, Sidenav-Item has no routeOrFunction set AND does not contain any subItems');
      }
    }
  }

  getTextIcon(item: SidenavCategory | SidenavItem | undefined) {
    let result = '';
    if (item && item instanceof SidenavCategory) {
      const name = item.categoryName.split(' ');
      if (name.length > 0) {
        result += name[0].charAt(0).toUpperCase();
      }
      if (name.length > 1) {
        result += name[1].charAt(0).toLowerCase();
      }
      if (name.length === 1) {
        result += name[0].charAt(1).toLowerCase();
      }
    } else if (item && item instanceof SidenavItem) {
      const name = item.itemName.split(' ');
      if (name.length > 0) {
        result += name[0].charAt(0).toUpperCase();
      }
      if (name.length > 1) {
        result += name[1].charAt(0).toLowerCase();
      }
      if (name.length === 1) {
        result += name[0].charAt(1).toLowerCase();
      }
    }
    return result;
  }

  hasSubItems(item: SidenavCategory |SidenavItem | undefined){
    if (item && item instanceof SidenavCategory){
      if (item.items) {
        return item.items.length > 0
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isCategory() {
    return !!((this.item instanceof SidenavCategory) && (this.item.isICategoryctive));
  }

  isItem() {
    return !!((this.item instanceof SidenavItem) && (this.item.isItemActive));
  }

  returnValueCategory(label: string) {
    return (this.item instanceof SidenavCategory) ? this.item.getValue(label) : null;
  }

  returnValueItem(label: string) {
    return (this.item instanceof SidenavItem) ? this.item.getValue(label) : null;
  }
  
  returnActiveCategory(label: string) {
    return (this.item instanceof SidenavCategory) ? (this.router.url !== this.item.getValue(label)) : false;
  }

  returnActiveItem(label: string) {
    return (this.item instanceof SidenavItem) ? (this.router.url !== this.item.getValue(label)) : false;
  }

}
